import { render, staticRenderFns } from "./ClientArea.vue?vue&type=template&id=4f6e90d5&scoped=true"
import script from "./ClientArea.vue?vue&type=script&lang=js"
export * from "./ClientArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e90d5",
  null
  
)

export default component.exports